{
  "app": {
    "name": "Villopia",
    "title": "Villopia — build your city, share it, watch it grow",
    "tagline": "Build your city. Share it. It grows on its own.",
    "seoTitle": "Villopia — the idle city builder that runs without you",
    "beta": "beta"
  },
  "boot": {
    "loading": "Loading your city…",
    "loadingAssets": "Preparing the ground…",
    "stage": "Phase 0 — foundations",
    "error": "The game failed to start.",
    "errorHint": "Reload the page. If it keeps happening, clear your browser cache."
  },
  "hud": {
    "grid": "Grid {cols} × {rows}",
    "perf": "{fps} fps · zoom ×{zoom} · quality {quality}",
    "expand": "Grow the grid",
    "shrink": "Shrink the grid",
    "recenter": "Recentre the view",
    "visitorsToday": "visitors received in total",
    "goalBuildings": "Unlock every building",
    "leagueNext": "{value} to go",
    "leagueMax": "top division",
    "online": "online",
    "onlineTitle": "Players connected right now"
  },
  "common": {
    "close": "Close",
    "cancel": "Cancel",
    "saveFailed": "Can’t save on this device",
    "saveFailedHint": "Storage full or private browsing — your progress may be lost."
  },
  "update": {
    "title": "New version available",
    "text": "Reload to get it — your city is already saved.",
    "action": "Refresh"
  },
  "install": {
    "title": "Install Villopia",
    "action": "Install",
    "ios": "Tap Share, then “Add to Home Screen”.",
    "why": "The game opens full screen and launches in one tap.",
    "done": "Already installed on this device."
  },
  "settings": {
    "title": "Settings",
    "language": {
      "label": "Language",
      "fr": "Français",
      "en": "English"
    },
    "sound": {
      "effects": "Effects volume"
    },
    "credits": {
      "label": "Credits",
      "open": "View credits",
      "title": "Credits"
    },
    "reset": {
      "label": "Start over",
      "open": "Erase my city",
      "title": "Erase everything?",
      "text": "Your city, coins, gems and progress will be gone for good. Your public address stays the same.",
      "confirm": "Erase"
    },
    "legal": "Legal notice, privacy and terms of sale",
    "account": {
      "label": "Account"
    },
    "preferences": {
      "label": "Preferences"
    },
    "about": {
      "label": "About"
    },
    "publisher": "Game published by"
  },
  "nav": {
    "label": "Navigation",
    "build": "Build",
    "city": "City",
    "social": "Social",
    "progress": "Progress",
    "games": "My games",
    "empty": {
      "build": {
        "title": "What you can build",
        "text": "Pick a building, place it, and watch your city spread."
      },
      "city": {
        "title": "Your city, at scale",
        "text": "This is where you’ll pick its theme, its monuments and the land you want to claim."
      },
      "social": {
        "title": "Who drops by",
        "text": "This is where you’ll see who visits your city, the boosts they bring and the notes they leave."
      },
      "progress": {
        "title": "Your climb",
        "text": "Your leagues, your milestones and your prestige — everything you’ve earned, in one place."
      },
      "games": {
        "title": "My other games",
        "text": "The other worlds from Villopia's creator await you here."
      }
    }
  },
  "shop": {
    "hint": "Drag the handle",
    "owned": "{count} owned",
    "production": "+{value}/s",
    "cancel": "Cancel",
    "auto": "Auto place",
    "quantityMax": "×MAX",
    "quantityLabel": "Quantity to place",
    "autoFor": "Place ×{count} · {value}",
    "topUpDone": "Balance topped up!",
    "topUpDoneText": "+{coins} coins for {gems} 💎",
    "topUpRefused": {
      "too-few-gems": "You need more gems to top up",
      "daily-cap": "You have used today's advances — come back tomorrow",
      "no-production": "Your city produces nothing: place a building first",
      "nothing-missing": "You can already afford it",
      "invalid": "Not possible right now"
    },
    "getGems": "Get gems",
    "topUp": "Top up · {value} 💎",
    "topUpUnavailable": "Place a building first",
    "readyInOrGems": "Ready in {value} · or {gems} 💎",
    "readyIn": "Ready in {value}",
    "placedMany": "{count} buildings placed",
    "groupAvailable": "Ready to build",
    "groupLocked": "To unlock",
    "unlockProgress": "{owned}/{need} to unlock",
    "unlocked": "New building unlocked!",
    "unlockedText": "{value} is waiting in the shop.",
    "groupDecor": "Decorate your city",
    "decorProduction": "Just for the looks",
    "decorPlaced": "Decoration placed!",
    "groupBag": "Your backpack",
    "bagProduction": "Place it wherever you like",
    "tabBuildings": "Buildings",
    "tabDecor": "Decor",
    "groupLandmark": "Landmarks — one of each per era",
    "tabLandmarks": "Landmarks",
    "landmarkOwned": "Standing in your city",
    "landmarkMissing": "{value} 💎 short",
    "placeLandmark": "Place · {value} 💎",
    "landmarkUnique": "Unique — one per era",
    "lockedTitle": "Not unlocked yet",
    "lockedHint": "Place {need} × {previous} to unlock {value} — you have {owned}.",
    "shortOnGems": "{value} 💎 short",
    "shortOnGemsHint": "To place {value} in your city."
  },
  "buildings": {
    "house": "House",
    "cottage": "Cottage",
    "streetStand": "Street stand",
    "grocery": "Grocery",
    "fishShop": "Fish shop",
    "restaurant": "Restaurant",
    "doctor": "Doctor's office",
    "cinema": "Cinema",
    "school": "School",
    "workplace": "Offices",
    "waterTower": "Water tower",
    "playground": "Playground",
    "poolClub": "Pool club",
    "helipad": "Helipad"
  },
  "milestones": {
    "firstBuilding": "First building: {value}",
    "land": "Land expansion no. {value}",
    "visitors": "{value} visitors received",
    "production": "{value} coins produced",
    "firstPrestige": "First new era",
    "roads": "{value} street tiles",
    "decor": "{value} decorations placed",
    "eras": "{value} eras behind you",
    "reward": "+{count} gems"
  },
  "units": {
    "perSecond": "{value}/s"
  },
  "duration": {
    "days": "{count}d",
    "hours": "{count}h",
    "minutes": "{count}m",
    "seconds": "{count}s"
  },
  "leagues": {
    "wood": "Wood",
    "stone": "Stone",
    "bronze": "Bronze",
    "silver": "Silver",
    "gold": "Gold",
    "diamond": "Diamond",
    "legend": "Legend"
  },
  "city": {
    "gridSize": "Land",
    "tabSummary": "Summary",
    "tabLand": "Land",
    "tabView": "View",
    "expansions": "Expansions",
    "buyLand": "Expand the land",
    "landCost": "{value} coins",
    "cleanRoads": "Clear the streets",
    "cleanRoadsFor": "Clear the streets · {count} tiles",
    "cleanedRoads": "Streets cleared!",
    "cleanedRoadsText": "{count} tiles are buildable again.",
    "landMaxed": "Land fully expanded",
    "landTitle": "Land",
    "viewTitle": "View",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "recenter": "Recentre the view",
    "collapse": "Collapse panel",
    "expand": "Expand panel",
    "landBought": "Land expanded!",
    "defaultName": "My city",
    "renameLabel": "Your city’s name",
    "rename": "Rename",
    "renameSave": "Save",
    "statsTitle": "Your city in numbers",
    "statBuildings": "Buildings",
    "statRoads": "Streets",
    "statProduction": "Production",
    "statVisitors": "Visitors received",
    "statEra": "Era",
    "eraValue": "Era {value} · ×{multiplier}",
    "sealed": {
      "weather": {
        "title": "Real weather",
        "text": "Soon: the weather outside your window will fall on your city."
      },
      "capsule": {
        "title": "Time capsule",
        "text": "Soon: a note sealed for 365 days, to reopen in a year."
      }
    },
    "renamed": "Your city has a new name",
    "renameRewarded": "City named! +{value} 💎 — and you’re now eligible for the ranking",
    "renameNudge": "Name your city to enter the ranking",
    "renameNudgeText": "Five seconds, plus {value} gems. Unnamed cities don’t appear.",
    "renameFailed": "Renaming did not go through"
  },
  "building": {
    "upgrade": "Upgrade",
    "upgradeCost": "Upgrade · {value}",
    "maxTier": "Top tier",
    "maxLevel": "Max tier",
    "maxLevelFor": "Max tier · {value} 💎",
    "maxedOut": "Building maxed out!",
    "maxedOutText": "{count} tier(s) at once — {gems} 💎",
    "rotate": "Rotate",
    "move": "Move",
    "sell": "Sell",
    "sellFor": "Sell · +{value}",
    "moveHint": "Tap a free cell to place the building.",
    "sold": "Building sold",
    "upgraded": "Building upgraded!",
    "tierGain": "Tier {value} of 3 · +{gain}/s if upgraded",
    "tierMax": "Tier {value} of 3 · maxed out",
    "sellConfirm": "Sell this building?",
    "sellConfirmText": "You get {value} coins back — half its price. It does not come back.",
    "remove": "Remove",
    "income": "Earns {value} coins/s",
    "incomeShare": "Adds {value} coins/s to your city",
    "incomeGrows": "Grows with your city"
  },
  "placement": {
    "tooExpensive": "Not enough coins",
    "tooExpensiveHint": "You are {value} short.",
    "occupied": "Cell taken",
    "occupiedHint": "Aim at a free cell, away from the streets.",
    "noSpace": "No room left on the island",
    "noSpaceHint": "Expand your land from the City tab.",
    "cancelled": "Placement cancelled",
    "decorHint": "Tap the tile where you want it",
    "decorStored": "Tucked into your backpack",
    "noAccess": "No street can reach it",
    "noAccessHint": "This spot would cut the city off from the rest of the island.",
    "roadTitle": "Remove this street?",
    "roadRemove": "Remove",
    "roadRemoved": "Street removed",
    "roadServes": "This street serves a building",
    "roadServesHint": "Removing it would leave a building with no access.",
    "roadSplits": "This street links two districts",
    "roadSplitsHint": "Removing it would cut the network in two.",
    "alreadyOwned": "Already yours",
    "alreadyOwnedHint": "One of each landmark per era."
  },
  "store": {
    "title": "Store",
    "bonus": "+{value} free",
    "treasure": "Your treasure",
    "treasureHint": "Earned through your milestones, quests and visitors",
    "balanceShort": "{value} gems",
    "popular": "POPULAR",
    "tabSpend": "Spend",
    "tabBuy": "Get gems",
    "soon": "Secure payment by Stripe. Your gems arrive as soon as the payment clears.",
    "soonTitle": "Not open yet",
    "failed": "The payment could not start",
    "paid": "Thank you for your purchase!",
    "paidText": "+{value} gems credited",
    "restored": "Your gems are back",
    "restoredText": "+{value} gems restored from your purchases",
    "canceled": "Payment cancelled — nothing was charged",
    "fairness": "Gems buy time, never an advantage: everything here can also be earned by playing.",
    "termsBefore": "By buying, you accept the ",
    "termsLink": "terms of sale",
    "termsAfter": " and request immediate delivery of your gems, which ends your right of withdrawal."
  },
  "progress": {
    "tabQuests": "Quests",
    "tabMilestones": "Milestones",
    "tabRanking": "Ranking",
    "tabEras": "Eras"
  },
  "quests": {
    "daily": "Today’s goals",
    "claim": "Claim",
    "claimed": "Claimed",
    "streak": "{value}-day streak",
    "streakReady": "{value} gems waiting",
    "streakDone": "Come back tomorrow for more",
    "build": "Place {value} buildings",
    "earn": "Earn {value} coins",
    "upgrade": "Upgrade {value} buildings",
    "land": "Expand your land {value} times",
    "visitors": "Welcome {value} visitors",
    "claimFor": "Claim · +{value} 💎",
    "weekly": "This week’s goals",
    "renewsIn": "renews in {value}"
  },
  "changelog": {
    "v1_15_0": {
      "i0": "Nothing changes in the game: the counter sent to Ludopia is fixed"
    },
    "v1_14_0": {
      "i0": "Nothing changes in the game: Villopia reports its player count to Ludopia"
    },
    "v1_13_0": {
      "i0": "A Ludopia account in settings: shared nickname, avatar and Ludos"
    },
    "v1_12_0": {
      "i0": "Villopia is getting ready to join the Ludopia platform"
    },
    "v1_11_0": {
      "i0": "Your public page shows who is watching your city live"
    },
    "v1_10_0": {
      "i0": "The ranking also tells you how many cities you're ahead of"
    },
    "v1_9_0": {
      "i0": "Your city shows its world rank on its public page"
    },
    "v1_8_0": {
      "i0": "Your buildings bob when they pay out a coin"
    },
    "v1_7_0": {
      "i0": "The ranking now counts total coins produced, not production per second"
    },
    "v1_6_0": {
      "i0": "+10 💎 per network you open — Discord, YouTube, TikTok"
    },
    "v1_5_0": {
      "i0": "Name your city: +25 💎, and you enter the ranking",
      "i1": "Cities still called “My city” no longer appear there"
    },
    "v1_4_0": {
      "i0": "Nothing changes in the game: your account is only created on your first building"
    },
    "v1_3_0": {
      "i0": "The game finally has music — switch it on in settings",
      "i1": "It never repeats, and it follows the day cycle"
    },
    "v1_2_0": {
      "i0": "Nothing changes in the game: server-side housekeeping"
    },
    "v1_1_0": {
      "i0": "The gaps between your buildings become gardens"
    },
    "v1_0_0": {
      "i0": "Streets finally have pavements, and they fill their whole tile",
      "i1": "No more grass strip between the road and your buildings"
    },
    "v0_99_1": {
      "i0": "Nothing changes in the game: groundwork for the road visual pass"
    },
    "v0_99_0": {
      "i0": "Tap a tree or a rock: you can clear it for coins",
      "i1": "And if you change your mind, nature comes back"
    },
    "v0_98_0": {
      "i0": "A world ranking: your place, and the fifty best cities",
      "i1": "Read it in Progress, Ranking tab"
    },
    "v0_97_0": {
      "i0": "Sharing a Villopia link finally shows a city, not a thumbnail",
      "i1": "The site is easier to find: title, description and sitemap"
    },
    "v0_96_1": {
      "i0": "The legal pages and the dashboard scroll again"
    },
    "v0_96_0": {
      "i0": "Nothing changes in the game: the internal dashboard no longer truncates its numbers"
    },
    "v0_95_0": {
      "i0": "Nothing changes in the game: the dashboard now separates real players from bots",
      "i1": "Five hundred cities a day — those were the probes"
    },
    "v0_94_1": {
      "i0": "Nothing changes in the game: the internal dashboard now says why it is empty",
      "i1": "A zero and a failed read no longer look alike"
    },
    "v0_94_0": {
      "i0": "Nothing changes in the game: the internal dashboard gains its charts",
      "i1": "Thirty-day curves, revenue, players per era"
    },
    "v0_93_0": {
      "i0": "Running short on coins now opens the remedy instead of stopping at a statement",
      "i1": "And the game can measure its own health — no cookies, no banner"
    },
    "v0_92_1": {
      "i0": "A landmark you can't afford says so BEFORE you aim at a tile",
      "i1": "No more shop opening wordlessly when you try to place"
    },
    "v0_92_0": {
      "i0": "Tap a building: you finally see what it earns, and why another is locked",
      "i1": "Bulk buying is now ×5 — the number that unlocks the next building"
    },
    "v0_91_0": {
      "i0": "Tabs stay visible while you scroll a menu",
      "i1": "And Bricolo gives you time to read: nine seconds instead of one and a half"
    },
    "v0_90_2": {
      "i0": "The settings window is centred again — it was stuck to the left",
      "i1": "Nothing had changed on phones; the defect only showed on large screens"
    },
    "v0_90_1": {
      "i0": "No more sideways drift in settings — it came down to two pixels",
      "i1": "And the box is wider on large screens: 520 px instead of 400"
    },
    "v0_90_0": {
      "i0": "Settings finally read as a column: everything aligned, nothing clipped",
      "i1": "And the email field sits on one line with its button"
    },
    "v0_89_1": {
      "i0": "The publisher is Ludopia.fr — the extension was wrong",
      "i1": "Nothing else changes"
    },
    "v0_89_0": {
      "i0": "Settings now sit in four sections: Language, Account, Preferences, About",
      "i1": "And the game finally names its publisher — Ludopia.app"
    },
    "v0_88_0": {
      "i0": "You can now opt in to news by email — a separate box, unchecked",
      "i1": "Unsubscribing is one tap, and your city follows you either way"
    },
    "v0_87_0": {
      "i0": "World Blocks joins “My games” — block puzzle and city building",
      "i1": "And taglines finally fit on two lines instead of cutting mid-word"
    },
    "v0_86_0": {
      "i0": "A landmark adds a share of what your city already makes — and its card shows the real gain",
      "i1": "It rides along with your run instead of replacing it: an era stays an era"
    },
    "v0_85_1": {
      "i0": "A placed landmark finally carries its name everywhere, not just in the shop",
      "i1": "And its panel no longer offers an upgrade: it's unique as it is"
    },
    "v0_85_0": {
      "i0": "You now choose WHERE your landmark goes — and you only pay when you place it",
      "i1": "And it no longer vanishes: a landmark has no upgrade, it's unique as it is"
    },
    "v0_84_2": {
      "i0": "Production maths does less work when you own no landmark yet",
      "i1": "Nothing changes on screen — the game just runs a little lighter"
    },
    "v0_84_1": {
      "i0": "A landmark that refuses now says why: “12 💎 short”",
      "i1": "And if it says nothing, you're short on space, not gems"
    },
    "v0_84_0": {
      "i0": "The bottom menu finally reads on a phone: three full buildings, nothing clipped",
      "i1": "And picking a building shows ×1 ×10 ×MAX right away"
    },
    "v0_83_0": {
      "i0": "Four gem landmarks: water tower, playground, pool, helipad",
      "i1": "One of each per era — and each is worth several of your best building"
    },
    "v0_53_0": {
      "i0": "Your gems finally do something: skip ahead, buy back your night, swap your quests.",
      "i1": "A broken streak can be restored — once a week, on the day it breaks.",
      "i2": "The land price in gems now shows where you run out of room.",
      "i3": "Finish Bricolo’s guide: your first ×2 is on the house."
    },
    "v0_52_0": {
      "i0": "Three speed-ups to choose from: ×2 for 30 min, ×3 for 2 h, ×5 for 8 h",
      "i1": "Your free ad and your bought speed-up finally stack instead of cancelling out",
      "i2": "Every active bonus shows its own countdown in the top bar"
    },
    "v0_51_0": {
      "i0": "Every button in the game is finally thumb-sized — gem counter and tutorial included"
    },
    "v0_50_0": {
      "i0": "Legal notice, privacy policy and terms of sale are online — from Settings",
      "i1": "You know exactly what data Villopia keeps: very little, and never your identity"
    },
    "v0_49_1": {
      "i0": "Rewarded ads always tell you what happened — and your daily quota stays intact when no ad is available"
    },
    "v0_49_0": {
      "i0": "The gem store opens for real — secure payment by Stripe",
      "i1": "A completed purchase always finds you, even if you close the game midway"
    },
    "v0_48_0": {
      "i0": "Your city in numbers, renaming, your milestone book and your division reach the screen",
      "i1": "\"Your visitors\" finally shows your count and your next trophy"
    },
    "title": "What’s new",
    "open": "What’s new in version {value}",
    "current": "current version",
    "v0_47_2": {
      "i0": "Street light glow springs from the lantern and shines from behind it",
      "i1": "Traffic lights light their real bulb: red on top, amber in the middle, green below"
    },
    "v0_47_1": {
      "i0": "Every halo sits EXACTLY on its lantern — pixel-measured, rotation by rotation",
      "i1": "Lighting peaks at dusk and dawn, dims at night, fades away in daytime"
    },
    "v0_47_0": {
      "i0": "At night, windows switch off and on as hours pass — your city is alive",
      "i1": "Street lamps finally glow, with a warm halo born at dusk",
      "i2": "No more ghost lights after moving a building or rotating the view"
    },
    "v0_46_0": {
      "i0": "Traffic lights and signs get a human size, level with street lamps",
      "i1": "Cars no longer overlap: wider lanes, and crossings are entered only when clear",
      "i2": "Junction surroundings are cleared — signage gets room to breathe"
    },
    "v0_45_0": {
      "i0": "Traffic lights REALLY arrive: T-crossings alternate lights and stop signs",
      "i1": "No more cars parked in the middle of a crossing — junctions always get cleared",
      "i2": "Street lights hug the edge of the roadway"
    },
    "v0_44_0": {
      "i0": "The Social tab shows Discord members and YouTube and TikTok followers"
    },
    "v0_43_0": {
      "i0": "Traffic lights finally light up: green, amber, red — cars obey what you see",
      "i1": "Up to 40 vehicles on the roads: the bigger your city, the busier it gets",
      "i2": "Lights turn green faster: no more endless waits at crossings",
      "i3": "Street lights and benches are glued to the road, forever — no building will evict them"
    },
    "v0_42_1": {
      "i0": "The header stays on one line when there's room, your boosts next to your production",
      "i1": "Placing a building on a street light or bench now removes it for good"
    },
    "v0_42_0": {
      "i0": "The gem store fits on screen and finally scrolls everywhere",
      "i1": "On phones, your active boosts no longer hide the top of the screen",
      "i2": "Discord, YouTube and TikTok are waiting in the Social tab",
      "i3": "The Progress tab lights up when a new era is ready"
    },
    "v0_41_0": {
      "i0": "Behind the scenes: a dashboard to watch over the game's health"
    },
    "v0_40_0": {
      "i0": "The store becomes a real showcase: big crystal, growing gem piles, golden popular pack",
      "i1": "Your treasure shows big, and every offer shows what it's worth",
      "i2": "Join the Villopia Discord from the Social tab!"
    },
    "v0_39_0": {
      "i0": "Bricolo, your foreman, welcomes you and shows you around — step by step, never blocking",
      "i1": "Build, expand, sign up, watch an ad: each step validates itself when you do it"
    },
    "v0_38_0": {
      "i0": "The store gets a facelift — wider, clearer, clean durations",
      "i1": "Pack payments are coming: the pipeline is in place, opening soon"
    },
    "v0_37_0": {
      "i0": "Watch an ad, earn ×2 production for 1 hour — three times a day",
      "i1": "The offer lives in the gem store, and it's the only free one"
    },
    "v0_36_0": {
      "i0": "Visitor keepsakes can be sold and moved — tap them!",
      "i1": "Two kinds of planters alternate, and every new keepsake falls from the sky",
      "i2": "On prestige, your visitors' keepsakes regrow in the new era"
    },
    "v0_35_0": {
      "i0": "Every multiplier shows its remaining time — gem rushes and visit boosts"
    },
    "v0_34_0": {
      "i0": "“My games” gets its own tab in the navigation bar",
      "i1": "On desktop, the shop stays full while you place — no more big empty void",
      "i2": "The placement buttons live at the top of the shop, always within reach"
    },
    "v0_33_1": {
      "i0": "The chosen building stays visible while you place — showcased in the action bar",
      "i1": "A “My other games” shelf appears under Progress"
    },
    "v0_33_0": {
      "i0": "In the shop, the chosen building slowly turns to show all its sides"
    },
    "v0_32_0": {
      "i0": "When you come back, your earnings rain from the sky and rush to your counter"
    },
    "v0_31_0": {
      "i0": "The screen shakes at the big moments — prestige, first milestone, new land — and only there"
    },
    "v0_30_0": {
      "i0": "Every visitor leaves a golden planter on your city",
      "i1": "At 25 visitors a bench appears, at 100 a fountain — share your link!"
    },
    "v0_29_0": {
      "i0": "Your visitors discover your city at golden hour, with a slow four-second approach",
      "i1": "And its streets feel three times more alive to them"
    },
    "v0_28_0": {
      "i0": "Every milestone bursts into particles — and confetti greets the first one of the session",
      "i1": "On prestige, your city flies away building by building before being reborn",
      "i2": "A newly unlocked building makes its entrance in the shop"
    },
    "v0_27_0": {
      "i0": "Neighbouring buildings gently step aside to make room for what you place"
    },
    "v0_26_0": {
      "i0": "Every gain bursts out of the building that produced it — “+12.4k” rises and fades",
      "i1": "The bigger the gain, the bigger it is written"
    },
    "v0_25_0": {
      "i0": "Your city is now saved in two sealed copies",
      "i1": "A brutally closed tab can no longer damage your game"
    },
    "v0_24_4": {
      "i0": "A technical error showed up in the console on every load — fixed",
      "i1": "Game images are back on their fast loading path"
    },
    "v0_24_3": {
      "i0": "Important confirmations always pre-select the safe button, in every language"
    },
    "v0_24_2": {
      "i0": "Every update is now checked automatically before going live"
    },
    "v0_24_1": {
      "i0": "Touching down while the preview is still loading is now honoured"
    },
    "v0_24_0": {
      "i0": "Each new era unlocks a brand-new building from the very first second",
      "i1": "The prestige screen announces what the next era will grant you",
      "i2": "Windows now wait for true night to light up, gently"
    },
    "v0_23_0": {
      "i0": "At night, your city's windows light up — and not all at once"
    },
    "v0_22_0": {
      "i0": "Grab a building and drag it: it lands where you let go",
      "i1": "Press and hold a placed building to lift it — no more menu",
      "i2": "A grid and a green or red footprint appear while you place",
      "i3": "While you place, the view no longer slides under your fingers"
    },
    "v0_21_0": {
      "i0": "Your land quests no longer break after a prestige",
      "i1": "Each new era really does start faster: 2.2 h, then 1.5 h, then 1.1 h"
    },
    "v0_20_0": {
      "i0": "The visitor counter finally moves — and pays out the gems it owes you",
      "i1": "First prestige now takes a real session, not thirty minutes",
      "i2": "Place ten buildings at once, or as many as your purse allows",
      "i3": "Your city no longer flickers while it reloads"
    },
    "v0_19_0": {
      "i0": "A volume slider, a credits screen, and the option to start over",
      "i1": "Browser zoom is no longer blocked, and the city has a name for screen readers",
      "i2": "Confirmation boxes finally focus the button that breaks nothing"
    },
    "v0_18_0": {
      "i0": "Every visit to your city boosts your production for 2h",
      "i1": "Visitors see they just helped you — and it makes them want to play",
      "i2": "Your link finally shows what it earns you"
    },
    "v0_17_0": {
      "i0": "Prestige is here: start your city over and keep a permanent bonus",
      "i1": "Your gems finally buy something — a boost and land",
      "i2": "Upgrading now costs the going rate, not a bargain price",
      "i3": "Daily goals no longer loop every three days"
    },
    "v0_16_0": {
      "i0": "Streets finally form a real network, and cars drive on it",
      "i1": "No more stray patches of tarmac in the middle of the houses",
      "i2": "A building you move keeps its access: the street follows it",
      "i3": "Tap a street to remove it",
      "i4": "Cities built before this update are repaired on load"
    },
    "v0_15_0": {
      "i0": "Panning the camera no longer drops a building by accident",
      "i1": "A refused purchase finally says why: too pricey, cell taken, or no room left",
      "i2": "Selling asks for confirmation, and says what you get back",
      "i3": "Escape, or a tap off the island, cancels a placement in progress"
    },
    "v0_14_0": {
      "i0": "A “Refresh” button appears as soon as a new version is available"
    },
    "v0_13_1": {
      "i0": "The closed drawer no longer peeks out behind the bottom bar"
    },
    "v0_13_0": {
      "i0": "Buildings now pick from a carousel, plus an invitation to install the game on your home screen"
    },
    "v0_12_0": {
      "i0": "One single top bar, twice as thin, and the menu hides so you can see your city"
    },
    "v0_11_0": {
      "i0": "Tighter top bar: more room for the city, and panels finally have depth"
    },
    "v0_10_5": {
      "i0": "This time for real: no more frozen loading screen after an update"
    },
    "v0_10_4": {
      "i0": "An update no longer breaks the game: the new version loads on its own"
    },
    "v0_10_3": {
      "i0": "One single address for your city: old links bring you straight there"
    },
    "v0_10_2": {
      "i0": "Phone in landscape: the city stays visible, the panel sits beside it"
    },
    "v0_10_1": {
      "i0": "The drawer title finally follows the open tab",
      "i1": "No more waiting screen sitting above the content it announced"
    },
    "v0_10_0": {
      "i0": "The Social tab finally exists: your public link, and one button to send it",
      "i1": "On phones, sharing goes through WhatsApp, SMS or Instagram in one gesture",
      "i2": "On desktop the link copies itself — and if nothing works, it stays selectable"
    },
    "v0_9_1": {
      "i0": "A BETA badge up top: the city is a work in progress, and it says so"
    },
    "v0_9_0": {
      "i0": "The city loads four times faster: sprites now live in a compressed atlas",
      "i1": "Your phone only downloads the buildings you actually own",
      "i2": "One draw batch per sheet instead of one per sprite: the city breathes better"
    },
    "v0_8_3": {
      "i0": "No more plinth under buildings: the paved lot is gone"
    },
    "v0_8_2": {
      "i0": "Every building now sits on a paved lot: the land you bought is finally visible",
      "i1": "Selling a building gives its lot back to the grass"
    },
    "v0_8_1": {
      "i0": "Every building shares one scale: windows, doors and floors are the right size everywhere",
      "i1": "No building spills over its plot onto its neighbours any more",
      "i2": "Heights are natural again: you can see the city behind the towers",
      "i3": "Sprites no longer linger in cache across versions — no more floating buildings"
    },
    "v0_8_0": {
      "i0": "Every building finally fills its plot — a street stand no longer dwarfs a clinic",
      "i1": "Towers are towers: no more height cap crushing the big buildings",
      "i2": "The sun comes from the right across the whole city, roofs and walls alike",
      "i3": "Awnings, balconies and roof overhangs now cast their shadow: volumes read clearly",
      "i4": "Blue sky above, warm bounce from the ground: façades breathe"
    },
    "v0_2_0": {
      "i0": "The top bar no longer covers the city on phones",
      "i1": "Milestones pay out the moment they are reached, even while idle",
      "i2": "No more impossible quests while visits don’t exist yet",
      "i3": "The app finally installs on phones (PWA)",
      "i4": "Fixed a renderer crash during the placement animation",
      "i5": "Clean console: audio no longer starts before the first gesture"
    },
    "v0_1_0": {
      "i0": "The isometric city: ten buildings, automatic roads, visual tiers",
      "i1": "The economy: coins, gems, milestones, land expansions",
      "i2": "Daily quests, weekly goals, login streak",
      "i3": "Local save and online player counter"
    },
    "v0_3_0": {
      "i0": "Your city saves online and gets its public address",
      "i1": "Link an email in Settings to find your city anywhere",
      "i2": "The visit page: your animated city, open to the world",
      "i3": "The version number at the bottom opens these notes"
    },
    "v0_4_0": {
      "i0": "Moving a large building by a single tile finally works",
      "i1": "A building can no longer be dropped onto a road",
      "i2": "The game warns you when it can’t save, instead of silently losing your run",
      "i3": "No more frozen rendering if you sell a building while its road is being drawn",
      "i4": "The top bar takes 25 % of the screen instead of 43 % — all the info, more city",
      "i5": "Two buildings placed in the same second no longer share an identity",
      "i6": "Your legacy monuments will no longer be wiped on reload"
    },
    "v0_5_0": {
      "i0": "Rotating the view no longer breaks anything: roads, trees and rocks turn with the ground",
      "i1": "Buildings no longer slip behind their own tile after a quarter turn",
      "i2": "Cars are finally visible — they were being drawn under the ground",
      "i3": "The placement preview shows the REAL model that will be placed (tier, variant, rotation)",
      "i4": "Coins take off from the centre of the building, no longer from empty ground",
      "i5": "Top bar: 21 % of the screen on mobile, a single band on desktop"
    },
    "v0_6_0": {
      "i0": "Your city produces while you’re away — and tells you what happened when you return",
      "i1": "A tab left open no longer pays twelve times too much: time off-screen counts as offline",
      "i2": "Quests roll over at midnight without reloading, and the login streak no longer breaks",
      "i3": "Winding back your phone clock no longer lets you re-claim quests on a loop",
      "i4": "Top bar reorganised: coins and gems on one line, no more clipped text late game"
    },
    "v0_6_1": {
      "i0": "Street lights, benches and bins finally line your streets — they shipped but were never placed",
      "i1": "Scenery now tells city from countryside: street furniture along the tarmac, nature elsewhere"
    },
    "v0_6_2": {
      "i0": "Bins, benches and street lights at their real size — a bin was as big as a tree",
      "i1": "Street furniture finally faces the road it sits on"
    },
    "v0_7_0": {
      "i0": "A single proportion rule for every prop — no more bin the size of a tree",
      "i1": "Street lights and benches hug the kerb, facing the road they sit on",
      "i2": "Top bar: league, visitors and online players finally aligned on one line"
    },
    "v0_7_1": {
      "i0": "Street lights all along your streets, evenly spaced — cadence is what makes a street"
    },
    "v0_7_2": {
      "i0": "The gem « + » button no longer spills out of the top bar"
    },
    "v0_7_3": {
      "i0": "No more trees along the tarmac: a tile that becomes a kerb now gets its street furniture"
    },
    "v0_61_0": {
      "i0": "A new game under “My games”: Tradopia, to learn the stock market by playing"
    },
    "v0_60_0": {
      "i0": "The gem shop gains colour: every pack wears its own, from smallest to most generous",
      "i1": "The ad offer no longer collapses into an unreadable column on phones"
    },
    "v0_59_0": {
      "i0": "When you are short on gems, the button takes you to the shop instead of refusing"
    },
    "v0_58_0": {
      "i0": "Whatever hides the building you are working on turns see-through — you finally see what you touch"
    },
    "v0_57_1": {
      "i0": "Scrollbars finally wear the game’s colours"
    },
    "v0_57_0": {
      "i0": "Your buildings no longer sit on a grey slab: they meet the ground, like the roads"
    },
    "v0_56_0": {
      "i0": "A card you cannot afford is no longer silent: it shows what you are missing and offers to top up with gems",
      "i1": "The price shows on the card BEFORE you tap it — “ready in 40s · or 2 💎”"
    },
    "v0_55_1": {
      "i0": "You can finally reach anywhere on the map — every corner of your city can be brought to the middle of the screen"
    },
    "v0_55_0": {
      "i0": "No more plots stuck under the menu: the city pans freely, and never leaves the screen",
      "i1": "The button that rotated the view by a quarter turn is gone"
    },
    "v0_54_6": {
      "i0": "The “Watch an ad” button gave nothing online — it hands out its bonus again"
    },
    "v0_54_5": {
      "i0": "A second silent start-up error was found and fixed: the console is empty again"
    },
    "v0_54_4": {
      "i0": "An error lingered in the console on every launch — it is gone"
    },
    "v0_54_3": {
      "i0": "Your visit counter went quiet for an hour this morning — fixed, and a probe now watches it"
    },
    "v0_54_2": {
      "i0": "Nothing new on screen: the probe watching the night lighting was measuring the wrong thing, now fixed"
    },
    "v0_54_1": {
      "i0": "Your account id is no longer visible from outside: nobody can tie your city back to you"
    },
    "v0_54_0": {
      "i0": "Gems you bought are now kept on the server: clearing your browser no longer loses them",
      "i1": "They come back on their own at load time, on any device you are signed in on"
    },
    "v0_53_1": {
      "i0": "Your older saves are locked down: an automatic check now verifies that no save loses anything between versions",
      "i1": "Nothing new on screen — this release publishes the gems, boosts and menus delivered yesterday"
    },
    "v0_62_0": {
      "i0": "Twelve decorations to place in your city, in gems: trees, bench, street lamp, fountain…",
      "i1": "They earn nothing on purpose — and they survive the change of era"
    },
    "v0_63_0": {
      "i0": "Build is now tabbed: Buildings on one side, Decorations on the other"
    },
    "v0_63_1": {
      "i0": "The tabs actually filter now, and they finally match the rest of the game"
    },
    "v0_63_2": {
      "i0": "Every decoration you buy now appears in your city — nine out of twelve stayed invisible",
      "i1": "What you paid for in gems stays yours, even after a reload"
    },
    "v0_64_0": {
      "i0": "You now choose WHERE to place a decoration, just like a building",
      "i1": "A backpack keeps everything you paid for — nothing is lost when an era ends",
      "i2": "City full? Buy anyway: your decoration waits for you in the backpack"
    },
    "v0_65_0": {
      "i0": "A bought decoration can now be sold back, prorated on what it cost you"
    },
    "v0_66_0": {
      "i0": "The fountain becomes a showpiece worth aiming for — the catalogue now runs 4 to 300 gems",
      "i1": "The shrub stays at 4 gems: the way in doesn't move"
    },
    "v0_67_0": {
      "i0": "Your decorations finally show up on your public page — that's what your friends see",
      "i1": "So do the flowers your visitors leave behind"
    },
    "v0_67_1": {
      "i0": "You can no longer build on a decoration: it holds its tile, just like a street",
      "i1": "Decorations already buried come back out on load — and can be sold again"
    },
    "v0_68_0": {
      "i0": "Upgrade too expensive? Take a building to its top tier with gems, in one tap",
      "i1": "The price is the wait you skip — no more, no less"
    },
    "v0_82_0": {
      "i0": "Tabs finally match from one menu to the next — same size, same icon, same pill",
      "i1": "And the Build ones are easier to tap: 48 px instead of 40"
    },
    "v0_81_1": {
      "i0": "No more red errors in the console: the game stopped asking for what isn't there",
      "i1": "Nothing changes on screen — this one's housekeeping"
    },
    "v0_81_0": {
      "i0": "The buy flow is fixed: packs come back to life behind their tab",
      "i1": "And the account invite never opens on an empty form again"
    },
    "v0_80_0": {
      "i0": "Leave your email and your city follows you across devices — offered three times, never forced",
      "i1": "Said no? The game goes quiet for a week. It still plays without an account"
    },
    "v0_79_0": {
      "i0": "Every era has its own light: the sky shifts hue when you start over",
      "i1": "And your public page shows YOUR light to whoever comes to look"
    },
    "v0_78_0": {
      "i0": "The store splits in two: Spend on one side, Get gems on the other",
      "i1": "And the TikTok link finally points to the right place"
    },
    "v0_77_0": {
      "i0": "The City section too: Summary, Land, View — each under its own tab"
    },
    "v0_76_0": {
      "i0": "Progress is tidied into tabs: Quests, Milestones, Eras — just like Build",
      "i1": "And when the game suggests something, it opens the right tab"
    },
    "v0_75_0": {
      "i0": "Nineteen more milestones: your street network, your decorations, your eras",
      "i1": "What you have already achieved is credited on load"
    },
    "v0_74_0": {
      "i0": "The milestone book opens up: tap a family and see what is coming",
      "i1": "And what it does not show, it tells you — the list never runs out"
    },
    "v0_73_0": {
      "i0": "Bricolo stays with you: he always says what to do next, and takes you there",
      "i1": "One tap folds him into a pill — and he remembers you put him away"
    },
    "v0_72_1": {
      "i0": "Deep inside a dense district, junctions finally get their lights and stop signs"
    },
    "v0_72_0": {
      "i0": "Streets that serve nothing can be cleared in one tap — the land comes back",
      "i1": "No useful street is touched, and the network stays in one piece"
    },
    "v0_71_0": {
      "i0": "When a new era opens, a banner tells you — with the bonus spelled out",
      "i1": "You can dismiss it: it stays gone, and the next era brings it back"
    },
    "v0_70_0": {
      "i0": "Upgraded buildings now wear their tier: two dots, three dots, above the roof"
    },
    "v0_69_0": {
      "i0": "Locked buildings now show what you are missing: “3/5” and a bar",
      "i1": "And when the door opens, you are told — even if you were watching your city"
    }
  },
  "accountInvite": {
    "title": "Keep your city",
    "later": "Later",
    "shared": "Your link is out there! Leave your email and your city follows you — phone, computer, anywhere, even if you switch devices.",
    "era": "New era reached, and your bonus is permanent. One email is all it takes so it no longer depends on this single browser.",
    "purchase": "Before you pay: leave your email. Gems bought on a browser you later clear are gems that are hard to get back."
  },
  "account": {
    "title": "Account",
    "anonymousHint": "Your city is tied to this browser. Add an email to find it anywhere.",
    "emailPlaceholder": "you@email.com",
    "sendLink": "Send me a link",
    "linkSent": "Link sent! Open the email to attach your city.",
    "linkError": "Sending failed. Check the address and try again.",
    "connectedAs": "City attached to {value}",
    "newsletter": "Send me Villopia news by email (optional)",
    "newsletterHint": "Nothing to do with your save: your city follows you either way.",
    "newsletterOn": "Noted — you'll get the news.",
    "newsletterOff": "Noted — you won't hear from us again.",
    "newsletterError": "Couldn't save your choice. Try again."
  },
  "visit": {
    "by": "A Villopia city",
    "cta": "Build your own — free",
    "prestige": "Era {value}",
    "rank": "#{rank} of {total} ranked cities",
    "rankFirst": "#1 in the world ranking",
    "live": "{value} people are watching this city right now",
    "notFound": "This city doesn’t exist (anymore).",
    "notFoundHint": "Check the link… or found your own — free, no account needed.",
    "boosted": "Your visit just boosted this city — thank you!",
    "legal": "Legal information"
  },
  "offline": {
    "welcomeBack": "Welcome back!",
    "earned": "+{value} coins produced while you were away ({duration})",
    "lead": "While you were away — {duration} — your city kept running.",
    "collect": "Collect",
    "efficiency": "A city without you produces at {value} % of its pace.",
    "capped": "{duration} more weren’t counted: offline production is capped.",
    "nightOffer": "Claim those {duration} · {value} 💎",
    "nightUsed": "All-nighter spent: 24 h counted, at half rate."
  },
  "social": {
    "waitingTitle": "Your city is claiming its address",
    "waitingText": "A few more seconds and you’ll have a link to send. Everyone who opens it makes your city produce faster.",
    "shareTitle": "Share your city",
    "pitch": "Every unique visitor doubles your production for two hours.",
    "rewarded": "Thanks! +{value} 💎",
    "rewardedText": "{value} 💎 left to claim on the other networks.",
    "linkLabel": "Public link to your city",
    "shareAction": "Send the link",
    "hint": "Visitors see your city animated, live. No account needed to look.",
    "shareSubject": "Villopia — {name}",
    "shareText": "Come see {name}, my city on Villopia. Your visit makes it grow.",
    "copied": "Link copied",
    "selectManually": "Copy the link shown",
    "discord": "Join the Villopia Discord",
    "discordName": "Discord",
    "youtube": "Villopia's YouTube channel",
    "youtubeName": "YouTube",
    "tiktok": "Villopia's TikTok",
    "tiktokName": "TikTok",
    "members": "{value} members",
    "followers": "{value} followers",
    "preview": "View my public page",
    "visitorsTitle": "Your visitors",
    "visitorsCount": "{value} visitors received",
    "tierNext": "{value} more visitors and your city earns {name}",
    "tierAll": "All visitor trophies placed — every visit still boosts you",
    "tier": {
      "bench": "a bench of honour",
      "fountain": "a fountain",
      "arch": "an arch",
      "goldenStatue": "a golden statue"
    }
  },
  "prestige": {
    "title": "New era",
    "readyTitle": "A new era is waiting",
    "readyText": "Your permanent bonus would rise to ×{value}. Your city restarts, the bonus stays.",
    "readyAction": "See",
    "era": "Era {value} · permanent bonus ×{multiplier}",
    "pitch": "Start your city over, and keep a production bonus forever. Each era runs faster than the last.",
    "becomes": "your bonus goes from ×{from} to ×{to}",
    "locked": "{value} more coins to produce in this era",
    "produced": "{value} / {target} produced this era",
    "keepsGems": "Your gems stay",
    "keepsMilestones": "The milestones you already earned stay",
    "keepsBonus": "Your permanent bonus adds up, it does not replace itself",
    "unlocks": "🎁 Next era unlocks: {value}",
    "loses": "You lose your city, your coins and your land — that is the price of the bonus.",
    "action": "New era",
    "actionReady": "New era · +{value} bonus",
    "confirm": "Start your city over?",
    "confirmText": "Your city, coins and land reset. You keep your gems, your milestones, and your bonus becomes ×{value}.",
    "done": "New era opened!",
    "doneText": "Permanent bonus ×{value}",
    "history": "{eras} era(s) behind you · this one running for {age} · {total} coins produced all-time"
  },
  "tutorial": {
    "welcome": "Welcome boss! I'm Bricolo, your foreman. Want a tour?",
    "build": "Let's start: open “Build” and place your first house — it produces coins on its own.",
    "land": "Your city will get cramped fast. In “City”, you can expand your land.",
    "account": "In “Social”, create your account: your city gets a shareable address, and every visit boosts you!",
    "ad": "A free boost? Tap your gems up top and watch an ad: ×2 production for 1 hour.",
    "done": "You know everything, boss! Back to the site — happy building 🏗️",
    "next": "Next",
    "later": "Later",
    "skip": "Skip",
    "finish": "Thanks Bricolo!"
  },
  "ads": {
    "offer": "Production ×{value} for {duration}, by watching an ad",
    "watch": "Watch · {value} left",
    "exhausted": "Come back tomorrow!",
    "rewarded": "Thanks for watching!",
    "aborted": "Ad interrupted — no reward",
    "unavailable": "No ad available right now — try again later"
  },
  "traces": {
    "title": "Visitor keepsake",
    "text": "A memento left by your visitors. Sell it, or place it wherever you like.",
    "sellFor": "Sell · {value}",
    "move": "Move",
    "moveHint": "Tap the tile where it should go",
    "sold": "Keepsake sold!",
    "soldText": "+{value} coins — thanks to your visitors",
    "rescued": "Decorations dug out",
    "rescuedMoved": "{count} decoration(s) sat under a building: they have been moved.",
    "rescuedStashed": "{count} paid decoration(s) went back to your bag — no room left."
  },
  "advisor": {
    "quest": "A quest is done — go collect your gems",
    "era": "A new era is waiting: your city restarts, the bonus stays",
    "bag": "{count} paid decoration(s) are sitting in your bag",
    "roads": "{count} street tiles serve nothing — take that land back",
    "land": "You can expand your land right now",
    "build": "You can afford a building — place one",
    "unlock": "{count} more to place to open the next building",
    "share": "Show your city: every visit makes it produce more",
    "fold": "Collapse Bricolo",
    "unfold": "Expand Bricolo"
  },
  "promo": {
    "title": "My other games",
    "hint": "From the same creator as Villopia — come take a look!",
    "play": "Discover",
    "tradopia": "Learn the stock market by playing — without risking a cent",
    "empty": "None for now — the next game will land here.",
    "worldblocks": "Block puzzle, city building and challenges with friends"
  },
  "gems": {
    "title": "Spend your gems",
    "rush": "×{value} production for {duration}",
    "rushBought": "Production boosted!",
    "land": "Expand the land right now",
    "landCost": "{value} 💎",
    "landBought": "Land expanded!",
    "tooFew": "Not enough gems",
    "tooFewHint": "Quests and milestones hand them out.",
    "rushTitle": "Speed up production",
    "rushTier": "×{value} · {duration}",
    "rushTierCost": "×{value} · {duration}\n{cost} 💎",
    "skipTitle": "Fast-forward production",
    "skipLeft": "Fast-forward production · {value} left today",
    "skipExhausted": "Fast-forward — come back tomorrow!",
    "skipTierCost": "{duration}\n{cost} 💎",
    "night": "All-nighter: your next return counts 24 h, at half rate",
    "nightCost": "{value} 💎",
    "nightReady": "In reserve",
    "reroll": "Swap today’s quests",
    "rerollCost": "{value} 💎",
    "rerollDone": "Already swapped today",
    "repairTitle": "Your {value}-day streak broke",
    "repairCost": "Restore · {value} 💎",
    "skipBought": "Time skipped!",
    "skipEmpty": "Place a building first — there is nothing to fast-forward.",
    "nightBought": "All-nighter in reserve!",
    "rerollBought": "Three new quests!",
    "repairDone": "Already restored this week",
    "repairBought": "Streak restored!",
    "gift": "Welcome gift",
    "giftText": "×{value} production for {duration}, on the house. That is what gems buy."
  },
  "visits": {
    "boostActive": "×{value} production thanks to your visitors",
    "boostNone": "Share your link: every visit boosts your production for 2h",
    "received": "New visitor! Production boosted",
    "boostActiveFor": "Boost ×{value} — {time} left"
  },
  "a11y": {
    "city": "Your city, seen from above"
  },
  "milestoneBook": {
    "title": "Milestone book",
    "summary": "{count} of {total} milestones claimed · {gems} gems earned",
    "family": "{done} of {total} earned in this family",
    "more": "+ {count} more behind, and the list never runs out",
    "done": {
      "first-building": "Every building in the catalogue has been born",
      "production": "Production has no summit — keep going",
      "land": "All the land is claimed",
      "roads": "Your network has reached its full span",
      "decor": "Your city is decorated exactly as you wanted",
      "eras": "Twenty-one eras — the city holds no more secrets",
      "visitors": "The crowds came — and keep coming",
      "prestige": "Your first era is behind you"
    }
  },
  "league": {
    "title": "Your division",
    "next": "{value} more coins produced to reach {name}",
    "soon": "Player rankings open soon — your division is already climbing."
  },
  "ranking": {
    "title": "World ranking",
    "own": "You are {rank} of {total} ranked cities",
    "percentile": "ahead of {value}% of cities",
    "era": "era {value}",
    "perSecond": "{value} coins produced",
    "reload": "Refresh",
    "loading": "Reading the ranking…",
    "offline": "Ranking unavailable offline — your city keeps producing.",
    "pending": "The ranking is computed server-side, several times a day. The first pass hasn’t run yet.",
    "unranked": "Your city isn’t ranked yet: place your first building and the next production will get you in.",
    "unnamed": "Your city is still called “My city” — rename it to enter the ranking and earn {value} 💎"
  },
  "ludopia": {
    "title": "Ludopia account",
    "pitch": "One nickname, one avatar and Ludos shared across every Ludopia game. Your city and your save don't change.",
    "connect": "Sign in with Ludopia",
    "disconnect": "Sign out of Ludopia",
    "purse": "{value} Ludos",
    "returnPending": "Exchanging with Ludopia…",
    "returnWelcome": "Welcome, {value}! Back to the game…",
    "returnRefused": "Ludopia refused this sign-in. Go back to the game and try again.",
    "returnNoVerifier": "Incomplete link: sign-in must start from the game.",
    "returnMissing": "No sign-in code in this link."
  },
  "clearing": {
    "title": "Clear",
    "confirm": "Clear",
    "askTitle": "Clear this tile for {value} coins?",
    "done": "Cleared — {value} coins",
    "regrowTitle": "Let nature take this tile back?",
    "regrown": "Nature is back",
    "tooExpensive": "You need {value} coins",
    "tooExpensiveHint": "The price rises with every clearing — it resets with the next era."
  },
  "decor": {
    "bush": "Shrub",
    "rock": "Rock",
    "rockTall": "Tall rock",
    "bin": "Bin",
    "tree": "Tree",
    "treeRound": "Round tree",
    "treeTall": "Tall tree",
    "potplants": "Potted plants",
    "flowerbed": "Flower bed",
    "bench": "Bench",
    "lamp": "Street lamp",
    "fountain": "Fountain"
  },
  "decorRefused": {
    "unknown": "Unknown decoration",
    "no-room": "Your city is full — expand your land",
    "no-island": "Not possible right now",
    "too-few-gems": "You need more gems"
  }
}
